<template><div><h1>VUX V2.5.9 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复格式为 YYYY 时的报错 #1861</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 点击当前日期项时不把值置为空 #1862</li>
</ul>
<h2><a href="/zh-CN/components/popup-header.html">PopupHeader</a></h2>
<ul><li>[fix] 修复错误的 slot 名字</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[feature] 修复当body没有设置100%宽度时出现的布局错乱问题 #1867</li>
</ul>
<h2><a href="/zh-CN/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] 修复 scrollTop 总是返回0的问题 #1827</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] prop:show 支持.sync修饰</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.9 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.9-251.vue?692ab002